/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Raw_Wide_Panda_BlendInputs */

const fr_raw_wide_panda_blend = /** @type {(inputs: Raw_Wide_Panda_BlendInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Programme déjà acquis`)
};

/**

* @param {Raw_Wide_Panda_BlendInputs} inputs
* @param {{ locale?: "fr" }} options
* @returns {LocalizedString}
*/
export const raw_wide_panda_blend = /** @type {((inputs?: Raw_Wide_Panda_BlendInputs, options?: { locale?: "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Raw_Wide_Panda_BlendInputs, { locale?: "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return fr_raw_wide_panda_blend(inputs)
});